import { jsx as _jsx } from "react/jsx-runtime";
// Adjust the import path to where your hook file is located
import { DatabaseContext, useDatabaseManager } from "../hooks/useSQLiteDatabase";
export var DatabaseProvider = function (_a) {
    var children = _a.children;
    // useDatabaseManager creates the state (the map of databases) and the functions to modify it.
    var manager = useDatabaseManager();
    // The Provider component makes this state and these functions available to any child component.
    return (_jsx(DatabaseContext.Provider, { value: manager.contextValue, children: children }));
};
